import { padNumber } from '@witmetrics/utils/numbers';

export const classes = {
  wrapper: 'flex hour-block',
  hour: 'relative px-3 text-[11.5px] top-[-0.75rem] text-right text-taupe-1 font-normal dark:text-mauve-3',
  offHours: 'bg-black/[0.02] dark:bg-white/[0.02]',
  onHours: 'bg-transparent',
  block:
    'w-full border-t border-solid border-black/[0.055] dark:border-white/[0.06]',
};

export const styles = {
  block: (height: number) => ({
    height: `${height}px`,
  }),
};

export function renderHour(hour: number) {
  return `${padNumber(hour)}:00`;
}

export function getMinutes(point: number) {
  if (point >= 0.75) return 45;
  else if (point >= 0.5) return 30;
  else if (point >= 0.25) return 15;
  return 0;
}
